import React, { useState, useEffect } from 'react';
import storage from 'utils/storage';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import CssBaseline from '@mui/material/CssBaseline';
import globalStyle from 'components/common/CommonStyled/GlobalStyle';
import { Global } from '@emotion/react/macro';
import getTheme from './theme';

const modes = ['light', 'dark'];

export default function Theme({ children }) {
  const [mode, setMode] = useState(0); // 0 or 1 => 0: light, 1: dark
  const theme = getTheme(modes[mode]);
  const isRtl = true;

  // Create rtl cache
  const cacheRtl = createCache({
    key: 'rtl',
    stylisPlugins: isRtl ? [prefixer, rtlPlugin] : [],
  });

  const setTheme = () => {
    storage.set({ theme: modes[Number(!mode)] });
    setMode(pervState => Number(!pervState));
  };

  // set current user theme
  // read that from localStorage
  useEffect(() => {
    const currentTheme = storage.get('theme');
    if (currentTheme && currentTheme !== modes[mode])
      setMode(Number(currentTheme === modes[1]));
  }, []);

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={{ ...theme, setTheme }}>
        <MuiThemeProvider theme={{ ...theme, setTheme }}>
          <CssBaseline />
          <Global styles={globalStyle} />
          {children}
        </MuiThemeProvider>
      </ThemeProvider>
    </CacheProvider>
  );
}
